<h2>What are you looking for?</h2>
<cui-smart-search-new-property-basic-details-form
  [formGroup]="stepFormGroup"
  [ageInYears]="ageInYears" />
<cp-stepper
  class="stepper"
  [forwardButtonEnabled]="stepFormGroup.valid"
  [hideProgressBar]="true"
  [showForwardButtonIcon]="false"
  [hideBackButton]="!isBackButtonVisible"
  [showSkipButton]="false"
  (forward)="emitNextClicked()"
  (back)="emitBackClicked()">
  <div class="stepper-content">
    <shared-labeled-value
      [valueStyle]="{ 'font-size': '1.5rem', 'margin-top': '0.5rem', 'font-weight': 'bold' }"
      label="LTV">
      @if (stepFormGroup.value.propertyPrice && stepFormGroup.value.deposit) {
        {{
          (stepFormGroup.value.propertyPrice - stepFormGroup.value.deposit) /
            stepFormGroup.value.propertyPrice | percent: "1.0-2"
        }}
      } @else {
        -
      }
    </shared-labeled-value>
    <shared-labeled-value
      [valueStyle]="{ 'font-size': '1.5rem', 'margin-top': '0.5rem', 'font-weight': 'bold' }"
      valueType="currency"
      [value]="stepFormGroup.value.propertyPrice - stepFormGroup.value.deposit"
      label="Mortgage amount">
      @if (stepFormGroup.value.propertyPrice && stepFormGroup.value.deposit) {
        {{
          stepFormGroup.value.propertyPrice - stepFormGroup.value.deposit
            | currency: "GBP" : "symbol" : "1.0-0"
        }}
      } @else {
        -
      }
    </shared-labeled-value>
  </div>
</cp-stepper>
